import axios from "axios";

const WALLET_BASE = "/admin/wallets/confiscate_requests";
const GROUP_APPROVE = "/admin/groups/wallet/confiscate_requests";

/**
 * Fetches confiscation requests filtered by status (default pending_approval).
 * Backed by the list endpoint added in the Phase 4 API diff.
 * @param {string} status - Request status to filter on
 * @param {Object} [options]
 * @param {AbortSignal} [options.signal] - Optional cancel signal
 * @returns {Promise<Object>} { page, per_page, total, pages, items }
 */
async function fetchConfiscateRequests(status = "pending_approval", { signal } = {}) {
    const { data } = await axios.get(WALLET_BASE, { params: { status }, signal });
    return data;
}

/**
 * Builds the axios config to approve a request, routing to the group or user
 * endpoint depending on the request target. Approval requires 2FA, so this
 * config is meant to be passed to runWith2FA.
 * @param {Object} req - The confiscation request item
 * @param {string} reason - The approver's justification
 * @returns {Object} Axios request config
 */
function buildApproveConfig(req, reason) {
    const url = req.target_group_id
        ? `${GROUP_APPROVE}/${req.id}/approve`
        : `${WALLET_BASE}/${req.id}/approve`;
    return { method: "post", url, data: { reason } };
}

/**
 * Rejects a pending confiscation request (no 2FA). Works for both user and
 * group requests since they share one table.
 * @param {number} requestId - The request id
 * @param {string} reason - Optional rejection reason
 * @returns {Promise<Object>} The updated request
 */
async function rejectConfiscateRequest(requestId, reason) {
    const { data } = await axios.post(`${WALLET_BASE}/${requestId}/reject`, { reason });
    return data;
}

export { fetchConfiscateRequests, buildApproveConfig, rejectConfiscateRequest };
